export var Separator;
(function (Separator) {
    Separator["AND"] = ",";
    Separator["RANGE"] = "-";
    Separator["INCREMENT"] = "/";
    Separator["NTH_WEEKDAY_OF_MONTH"] = "#";
})(Separator || (Separator = {}));
